import React, { Component } from 'react'
import { SearchBarTable } from 'hljd'
import getColumns from './columns'
import { inject } from 'mobx-react'
import styles from '../style.module.less'

@inject('store')
export default class extends Component {
  render() {
    return (
      <SearchBarTable
        rowKey="key"
        className={styles.table_wrap}
        style={{ marginTop: 20 }}
        store={this.props.store}
        columns={getColumns(this.props.store)}
      />
    )
  }
}
